import { ValidationStatus } from "@bvhi/backend-api/apis";
import { Chip } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  status?: string;
  size?: "small" | "medium";
}

export function ValidationStatusChip({ status, size = "small" }: Props) {
  const { t } = useTranslation(["enums"]);

  const label = useMemo(() => {
    if (!status) return t("enums.validation.status.no.content");
    if (status === ValidationStatus.OPEN) return t("enums:enums.validation.status.open");
    if (status === ValidationStatus.VALID) return t("enums:enums.validation.status.valid");
    if (status === ValidationStatus.INVALID) return t("enums:enums.validation.status.invalid");

    return "";
  }, [status, t]);

  const color = useMemo(() => {
    if (!status) return "info";
    if (status === ValidationStatus.OPEN) return "info";
    if (status === ValidationStatus.VALID) return "success";
    if (status === ValidationStatus.INVALID) return "error";

    return "error";
  }, [status]);

  return <Chip color={color} label={label} size={size} />;
}
